module.exports = __webpack_public_path__ + "static/psych-cards-7fa5e9b5bb7132095aa1804e928d1836.jpg";